.container {
  height: 100%;
  margin-top: 1px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--txt-mask);
}

.notReadyWrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--bg-base-light);
}

.iconCatInBag {
  background-image: url(./assets/loading-cat.png);
  background-repeat: no-repeat;
  height: 212px;
  width: 400px;
  background-size: contain;
}

.text {
  margin-top: 24px;
  white-space: pre;
}
